module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/371487336c561dcd0600979d35656796.png";